
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import commonService from '@/services/common-services';
import { APP_CONFIG } from '@/config/app-config';
import { Customer } from '@/models/customer';
import { DATA } from '@/config/data';

@Component
export default class ProfileRight extends Vue {
    @Prop({default: null})
    private customer!: Customer;

    @Prop({default: null})
    private submitForm!: any;

    @Watch('submitForm', { immediate: true, deep: true })
    private async watchSubmitForm() {
        if (this.submitForm) {
            if (await this.validateForm() === true) {
                await this.submitForm();
            }
        }
    }

    private listCallingCode = DATA.callingCodes;

    private tab = {
        customerInfo: 'customerInfo',
        password: 'password',
        receivePlace: 'receivePlace'
    }
    private selectedTab = this.tab.customerInfo;

    private onSelectedTab(tab: any) {
        this.selectedTab = tab;
    }

    private onSelectStoreArea(store: any) {
        this.customer.ReceivePlaceID = store.ID;
    }

    get warehouse() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].warehouse;
    }

    private async getWarehouse() {
        const result = await commonService.getWarehouse();
        if (result && result.status === 200) {
            (window['getApp'] as any).$emit('SET_WAREHOUSE', result.data.data);
        }
    }

    private async validateForm() {
        const valid = this.$refs['observer'] as any;

        if (!valid) {return false;}
        if (await valid.validate() === true) {return true;}

        if (valid.refs['RePassword'].flags.valid === false || valid.refs['Password'].flags.valid === false) {
            this.selectedTab = this.tab.password;
            return false;
        }

        this.selectedTab = this.tab.customerInfo;
        return false;

    }

    private async created() {
        if (!this.warehouse) {
            await this.getWarehouse();
        }
    }
}
